var WDN = WDN || {};

class WDNElement extends HTMLElement {
  constructor() {
    super();

    // shared states between components
    this.setupStates = function () {
      // will create attribute as "data-[array key]""
      var statesToHandle = ["loading", "disabled", "active", "hide"];

      statesToHandle.forEach(function (label) {
        // functions to update state, called like => this.loading(); this.loading(false);
        this[label] = this.updateAttribute(label);
      }, this);
    };

    this.initWDNElement = function () {
      this.setupStates();
    };

    this.initWDNElement();
  }

  /* ADDING EVENT LISTENERS FOR LIST OF ITEMS */
  on(event, selector, toDo) {
    /*
         param @event *string
         - name of event you want to listen for,
         e.g.: click, mouseover, etc.

         param @selector *string
         - HTML selector to use, can be class, data-attribute etc.

         param @toDo *function
         - your function
         */

    var list = this.querySelectorAll(selector);

    list.forEach(function (item) {
      item.addEventListener(event, toDo);
    });
  }

  updateAttribute(name) {
    return function (value) {
      var attrName = "data-" + name;
      // eg. this.loading(); this.loading(true)
      if (typeof value === "undefined" || value) {
        this.setAttribute(attrName, "");
      } else {
        this.removeAttribute(attrName);
      }
    }.bind(this);
  }

  // helper function for having a custom events
  customEvent(data) {
    var newEvent = new CustomEvent(data.name, {
      detail: data.detail,
    });
    if (data.target) {
      var target = document.querySelector(data.target);
    }
    if (!target) {
      var target = document.body;
    }
    target.dispatchEvent(newEvent);
  }

  // adds event to window
  addEvent(event, func) {
    return window.addEventListener(event, func);
  }
  // removes event from window
  removeEvent(event, func) {
    return window.removeEventListener(event, func);
  }
}

class WDNDropdown extends HTMLElement {
  constructor() {
    super();
    this.buildConstructor();
    this.init();
  }

  configureAttributes() {
    this.nameSpace = this.getAttribute("data-name") || "dropdown";

    this.selectors = {
      trigger: "[" + this.nameSpace + "-trigger]",
      container: "[" + this.nameSpace + "-container]",
      content: "[" + this.nameSpace + "-content]",
    };

    this.attributeList = {
      group: "group",
      active: this.nameSpace + "-active",
    };
  }

  buildConstructor() {
    this.configureAttributes();
    this.id = this.getAttribute("data-id");
    this.trigger = this.querySelector(this.selectors.trigger);
    this.container = this.querySelector(this.selectors.container);
    this.content = this.querySelector(this.selectors.content);
    this.group = this.getAttribute(this.attributeList.group);
    this.isActive = this.getAttribute(this.attributeList.active) === "";
  }

  setState(newState) {
    this.isActive = newState;
  }

  setContainerHeight(newHeight) {
    this.container.style.height = newHeight + "px";
  }

  shrinkContainer() {
    this.setContainerHeight(0);
  }

  expandContainer() {
    var contentHeight = this.content.offsetHeight;
    this.setContainerHeight(contentHeight);
  }

  setInactive() {
    this.setState(false);
    this.removeAttribute(this.attributeList.active);
    this.shrinkContainer();
  }

  setActive() {
    this.collapseGroupContainers();
    this.setState(true);
    this.setAttribute(this.attributeList.active, "");
    this.expandContainer();
  }

  fireGroupEvent() {
    var customEvent = new CustomEvent("dropdown:group:collapse", {
      detail: { group: this.group },
    });
    document.body.dispatchEvent(customEvent);
  }

  collapseGroupContainers() {
    if (this.group) {
      this.fireGroupEvent();
    }
  }

  fireToggleEvent() {
    document.body.dispatchEvent(new CustomEvent("toggle", { detail: this }));
  }

  onTriggerClick() {
    if (this.isActive) {
      this.setInactive();
    } else {
      this.setActive();
    }
    this.fireToggleEvent();
  }

  onWindowResize() {
    if (this.isActive) {
      this.expandContainer();
    }
  }

  onGroupCollapse(e) {
    if (this.group === e.detail.group) {
      this.setInactive();
    }
  }

  setInitialState() {
    if (this.isActive) {
      this.expandContainer();
    }
  }

  dropdownChildOnToggle(e) {
    if (this == e.detail) return;
    if (this.isActive && this.contains(e.detail)) {
      var timeout = 240;
      setTimeout(
        function () {
          this.expandContainer();
        }.bind(this),
        timeout
      );
    }
  }

  bind() {
    this.trigger.addEventListener("click", this.onTriggerClick.bind(this));
    document.body.addEventListener("dropdown:group:collapse", this.onGroupCollapse.bind(this));
    window.addEventListener("resize", this.onWindowResize.bind(this));
    document.body.addEventListener("toggle", this.dropdownChildOnToggle.bind(this));
  }

  init() {
    this.setInitialState();
    this.bind();
  }
}

if (!customElements.get("wdn-dropdown")) {
  customElements.define("wdn-dropdown", WDNDropdown);
}

if (!customElements.get("wdn-cart-count")) {
  class WDNCartCount extends HTMLElement {
    constructor() {
      super();
      this.value = parseInt(this.getAttribute("data-value"));
      this.init();
    }

    show() {
      this.removeAttribute("data-hide");
    }

    hide() {
      this.setAttribute("data-hide", "");
    }

    toggle() {
      if (this.value > 0) {
        this.show();
      } else {
        this.hide();
      }
    }

    setValue(newValue) {
      this.value = parseInt(newValue);
      this.innerHTML = newValue;
      this.toggle();
    }

    onSet(e) {
      var newValue = e.detail;
      this.setValue(newValue);
    }

    onCartAdd(e) {}

    fireUpdatedEvent(res) {
      var newEvent = new CustomEvent("cart:updated", { detail: res });
      document.body.dispatchEvent(newEvent);
    }

    onCartFetch(res) {
      this.fireUpdatedEvent(res);
      this.setValue(res.item_count);
    }

    onCartError() {}

    updateCartCount() {
      WDN.Cart.Get({
        onSuccess: this.onCartFetch.bind(this),
        onError: this.onCartError.bind(this),
      });
    }

    bind() {
      document.body.addEventListener("cartcount:set", this.onSet.bind(this));
      document.body.addEventListener("cartcount:update", this.updateCartCount.bind(this));
    }

    init() {
      this.bind();
    }
  }

  customElements.define("wdn-cart-count", WDNCartCount);
}

// mobile menu

WDN.Header = (function () {
  var menu_open = document.querySelector(".menu-trigger");
  if (!menu_open) {
    return;
  }

  var mobile_close = document.querySelector(".m_menu__head__close-icon");
  var menu_overlay = document.querySelector(".m_menu_overlay");

  var body = document.querySelector("body");

  var mobile_menu = document.querySelector(".m_menu");

  const openMenu = function () {
    mobile_menu.classList.add("menu-toggle");
    menu_overlay.classList.add("toggle-overlay");
    body.classList.add("body-no-scroll");
  };

  const closeMenu = function () {
    mobile_menu.classList.remove("menu-toggle");
    menu_overlay.classList.remove("toggle-overlay");
    body.classList.remove("body-no-scroll");
  };

  menu_open.addEventListener("click", openMenu);
  mobile_close.addEventListener("click", closeMenu);
  menu_overlay.addEventListener("click", closeMenu);
})();

/* Percentage timer */
(function () {
  var init, start_timer;
  var animate_numbers;

  var ingredients_section = document.querySelector(".product__ingredients");
  if (ingredients_section) {
    var percentage_containers = ingredients_section.querySelectorAll("[data-ingredient-percentage]");
  }

  start_timer = function (container) {
    var goal = parseFloat(container.getAttribute("data-ingredient-percentage"));
    var step = 1;
    var current = 0;
    var timeout = 20;

    var interval = setInterval(function () {
      container.innerHTML = current + "%";
      current = current + step;

      if (current > goal) {
        clearInterval(interval);
        container.innerHTML = goal + "%";
      }
    }, timeout);
  };

  animate_numbers = function () {
    percentage_containers.forEach(function (container) {
      start_timer(container);
    });
  };

  init = function () {
    if (!ingredients_section) return;
    animate_numbers();
  };

  init();
})();

/* Product quantity */

(function () {
  var init, bind, assign_input;
  var handle_control_click, set_input_value;

  var nodes = {
    increase_button: document.querySelector('[data-product-quantity="increase"]'),
    decrease_button: document.querySelector('[data-product-quantity="decrease"]'),
    input: false, // will be assigned on init
  };

  set_input_value = function (new_value) {
    if (!new_value) return;
    nodes.input.value = new_value;
  };

  handle_control_click = function () {
    var action = this.getAttribute("data-product-quantity");
    var step = +1;
    if (action === "decrease") {
      step = -1;
    }
    set_input_value(parseInt(nodes.input.value) + step);
  };

  bind = function () {
    nodes.increase_button.addEventListener("click", handle_control_click);
    nodes.decrease_button.addEventListener("click", handle_control_click);
  };

  assign_input = function () {
    var input_id = nodes.increase_button.getAttribute("data-for");
    nodes.input = document.querySelector("input[id='" + input_id + "']");
  };

  init = function () {
    if (!nodes.increase_button || !nodes.increase_button) return;
    assign_input();
    bind();
  };

  init();
})();

/* Featured collection form */
(function () {
  var section = document.querySelector(".featured-col__product");
  if (section) {
    var form = section.querySelector("form");
  }

  // init form
  if (form) {
    new theme.AjaxProduct(form, "[data-add-to-cart]");
  }
})();

/* Main product - scroll to ingredients  */

(function () {
  var handle_trigger_click;
  var triggers = document.querySelectorAll("[data-scroll-to]");

  handle_trigger_click = function () {
    var target_selector = this.getAttribute("data-scroll-to");
    if (target_selector == "") return;
    var target = document.querySelector(target_selector);
    if (!target) return;

    target.scrollIntoView({ behavior: "smooth" });
  };

  triggers.forEach(function (trigger) {
    trigger.addEventListener("click", handle_trigger_click);
  });
})();
